import styled, { css } from 'styled-components';
import { Container } from '../../theme/layout';
import { media } from '../../theme/media';
import { colors, headerSize } from '../../theme/styled';
import { HeaderStyle } from '../../reducers/menu/menu.redux';
import { SkipNavigationButton } from '../../components/skipNavigationButton';

const opaqueBackground = css`
  background-color: ${colors.darkGrey};
`;

const shouldBeOpaque = props => {
  const isRelative = props.headerStyle === HeaderStyle.RELATIVE;
  const isMinimal = props.headerStyle === HeaderStyle.MINIMAL;
  const isScrolled = props.scrolledTop;
  return !isMinimal && (isRelative || !isScrolled || (props.isOpened && props.showsBurgerMenu));
};

const shouldBeSmall = props => props.headerStyle === HeaderStyle.MINIMAL;

export const navHiddenStyle = css`
  transform: translateY(-184px);
`;

export const Header = styled.header`
  display: contents;
  z-index: 7;
`;

// This sticks to the top of the page if appropriate.
export const StickyContainer = styled.div`
  position: ${props => (props.shouldStick ? 'sticky' : 'relative')};
  top: 0;
  width: 100%;
  z-index: 6;
  pointer-events: ${props => (props.hiddenByScroll ? 'none' : null)};
`;

export const HeightModulatedContainer = styled.div`
  height: ${props => (props.shouldOverlap ? 0 : null)};
  pointer-events: ${props => (props.hiddenByScroll ? 'none' : null)};
`;

export const HiddenOnScrollContainer = styled.section`
  transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden;
  position: relative;
  z-index: 5;

  width: ${props => (props.headerStyle === HeaderStyle.MINIMAL ? 'auto' : '100%')};
  ${props => (props.hiddenByScroll ? navHiddenStyle : '')};
  transition: transform ${props => (props.isCategoryMenuVisible ? '.5s' : '.7s')} ease-in-out;
  pointer-events: ${props => (props.hiddenByScroll ? 'none' : null)};
  will-change: transform;
`;

export const Nav = styled.nav`
  width: ${props => (shouldBeSmall(props) ? 'auto' : '100%')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 24px;
  background-image: ${props =>
    props.headerStyle === HeaderStyle.MINIMAL
      ? 'none'
      : 'linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))'};

  ${props => shouldBeOpaque(props) && opaqueBackground};
  transition: background-color 0.2s ease-in-out;

  ${media.tabletLarge`
    padding-left: 40px;
  `};
`;

export const MenuContainer = styled(Container)`
  margin: 0 auto;
  justify-content: flex-end;
  height: ${headerSize.mobile}px;
  position: relative;

  ${media.mobile`
    padding-left: 25px;
  `};

  ${media.tabletLarge`
    padding-left: 40px;
  `};

  ${media.desktopSmall`
    height: ${headerSize.desktop}px;
  `}
`;

export const SkipNavButton = styled(SkipNavigationButton)`
  position: absolute;
  left: -200%;

  &:focus {
    left: 24px;
    bottom: -36px;

    ${media.tablet`
    left: 342px;
    bottom: auto;
   `};

    ${media.tabletLarge`
    left: 359px;
  `};
  }
`;
